import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const AdminLogin = ({
	password,
	onPasswordChange,
	onSubmit,
}: {
	password: string;
	onPasswordChange: React.ChangeEventHandler<HTMLInputElement>;
	onSubmit: () => void;
}) => {
	return (
		<div className="p-4 sm:p-12 border border-black rounded-xl shadow-xl">
			<h2 className="text-2xl font-bold mb-4 text-center text-gray-900">Admin Login</h2>
			<Input
				type="password"
				value={password}
				onChange={onPasswordChange}
				placeholder="Enter Admin Password"
				className="w-full"
			/>
			<Button
				onClick={onSubmit}
				className="w-full bg-gray-950 py-2 mt-4 rounded hover:bg-gray-800"
			>
				Submit
			</Button>
		</div>
	);
};

export default AdminLogin;
